import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { isNullOrEmpty } from '../../../core/public-api';
import {
  HintDialogOption,
  HintDialogService,
} from '../../../core/services/hint-dialog.service';

@Component({
  selector: 'sigv-hint-dialog-container',
  templateUrl: './hint-dialog-container.component.html',
  styleUrls: ['./hint-dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintDialogContainerComponent implements OnInit {
  hintDialogOptions: HintDialogOption[] = [];
  subscription: Subscription;
  clearSignal: Subscription;

  constructor(
    private hintDialogService: HintDialogService,
    private cd: ChangeDetectorRef
  ) {
    this.subscription = this.hintDialogService.requireHintDialog$.subscribe(
      (option) => {
        if (isNullOrEmpty(option)) {
          return;
        }
        this.hintDialogOptions.push(option!);
        this.cd.detectChanges();
      }
    );
    this.clearSignal = this.hintDialogService.clearHintDialogSource$.subscribe(
      () => {
        this.hintDialogOptions = [];
        this.cd.detectChanges();
      }
    );
  }

  ngOnInit(): void {}

  onDialogConfirm(index: number, event: any): void {
    const option = this.hintDialogOptions[index];
    // 為避免p-dialog的hide觸發cancel時option為空加上？
    if (isNullOrEmpty(option?.acceptFunc) === false) {
      option.acceptFunc!(event);
    }
    this.hintDialogOptions.splice(index, 1);
    this.cd.detectChanges();
  }

  onDialogCancel(index: number, event: any): void {
    const option = this.hintDialogOptions[index];
    // 為避免p-dialog的hide觸發cancel時option為空加上？
    if (isNullOrEmpty(option?.rejectFunc) === false) {
      option.rejectFunc!(event);
    }
    this.hintDialogOptions.splice(index, 1);
    this.cd.detectChanges();
  }
  /**
   * 訊息後處理
   * @param useMsg
   */
  msgProcess(useMsg: string, last?: boolean) {
    const specialProcess = (key: string) => {
      if (key.includes('MAX_LENGTH')) {
        useMsg = 'Library.FormValidErrorMsg.MAX_LENGTH_HINT';
      }
      if (key.includes('MIN_LENGTH')) {
        useMsg = 'Library.FormValidErrorMsg.MIN_LENGTH_HINT';
      }
      if (key.includes('EXCEED_MAXIMUM_DATE_RANGE')) {
        useMsg = 'Library.FormValidErrorMsg.EXCEED_MAXIMUM_DATE_RANGE_HINT';
      }
    };
    if (last) {
      useMsg = useMsg.split('{{count}}')?.[1] ?? '';
    } else {
      useMsg = useMsg.split('{{count}}')[0];
      specialProcess(useMsg);
    }
    return useMsg;
  }
  msgDisplay(useMsg: any) {
    let display = true;
    if (useMsg.includes('DATE_END_COMP', 'DATE_START_COMP')) {
      display = false;
    }
    return display;
  }
}
